<template>
	<div class="d-flex align-center">
		<template>
			<TallyPatientFormDialog
				v-model="showTallyForm"
				:UserId="tallyFormUserId"
			></TallyPatientFormDialog>
			<CreateBookingDialog
				v-model="showCreateBookingDialog"
				:PatientUserId="createBookingUserId"
				@bookingCreated="OnBookingCreated"
			>
			</CreateBookingDialog>
		</template>
		<v-icon v-if="loading" color="blue darken-2 "
				class="mr-6"
				size="28">fad fa-spinner fa-spin</v-icon>
		<v-menu>
			<template v-slot:activator="{ on, attrs }">
				<v-icon v-show="!loading" v-bind="attrs" v-on="on"
						color="blue darken-2"
						class="mr-3"
						size="28"
					>
					far fa-caret-circle-down</v-icon
				>
			</template>
			<v-list>
				<v-list-item @click="showTallyPatientForm">
					<v-list-item-action
						><v-icon color="primary"
							>fas fa-fw fa-info</v-icon
						></v-list-item-action
					>
					<v-list-item-title> Info Del Paziente</v-list-item-title>
				</v-list-item>
				<v-list-item @click="showBookingDialog">
					<v-list-item-action
						><v-icon color="primary"
							>fas fa-fw fa-plus-square</v-icon
						></v-list-item-action
					>
					<v-list-item-title>Nuovo Appuntamento</v-list-item-title>
				</v-list-item>
				<v-menu offset-x>
					<template v-slot:activator="{ on, attrs }">
						<v-list-item v-bind="attrs" v-on="on">
							<v-list-item-action
							><v-icon
							>fa-fw far fa-file</v-icon
							></v-list-item-action
							>
							<v-list-item-title>File</v-list-item-title>
						</v-list-item>
					</template>
					<v-card min-width="300" max-width="400">
						<v-card-title>I file della conversazione</v-card-title>
						<v-card-text
							style="max-height: 300px; overflow-y: auto; overflow-x: hidden;	"
						>
							<!-- Your file-related content here -->
							<ConversationFiles
								:UserId="Conversation.UserId"
							></ConversationFiles>
						</v-card-text>
					</v-card>
				</v-menu>
				<v-divider></v-divider>
				<v-list-item
					v-if="!Conversation.IsArchived"
					@click="ArchiveConversation()"
				>
					<v-list-item-action
						><v-icon>fas fa-inbox-in</v-icon></v-list-item-action
					>
					<v-list-item-title>Archivia</v-list-item-title>
				</v-list-item>
				<v-list-item v-else @click="UnarchiveConversation()">
					<v-list-item-action
						><v-icon>fas fa-inbox-out</v-icon></v-list-item-action
					>
					<v-list-item-title>Sposta in inbox</v-list-item-title>
				</v-list-item>

			</v-list>
		</v-menu>
	</div>
</template>
<script>
import CrudClient from "@/services/CrudClient/";
import CreateBookingDialog from "@/views/Nutritionists/components/CreateBookingDialog";
import TallyPatientFormDialog from "@/views/Nutritionists/components/TallyPatientFormDialog";
import ConversationFiles from "@/components/Chat/ConversationFiles";

export default {
	components: {
		CreateBookingDialog,
		TallyPatientFormDialog,
		ConversationFiles
	},
	data() {
		return {
			PatientsService: new CrudClient("CurrentNutritionist/Patients"),
			chatService: new CrudClient("Chat"),
			showCreateBookingDialog: false,
			showTallyForm: false,
			createBookingUserId: null,
			tallyFormUserId: null,
			loading: false
		};
	},
	props: {
		Conversation: {
			type: Object,
			required: true
		}
	},
	watch: {
		showCreateBookingDialog: function(val) {
			if (!val) {
				this.createBookingUserId = null;
			}
		}
	},
	mounted() {
		this.$log.debug("NutritionistListItemActions mounted UserId: " + this.Conversation.UserId);
	},
	methods: {
		showTallyPatientForm() {
			this.tallyFormUserId = this.Conversation.UserId;
			this.showTallyForm = true;
		},
		showBookingDialog() {
			this.createBookingUserId = this.Conversation.UserId;
			this.showCreateBookingDialog = true;
		},
		async OnBookingCreated() {
			this.createBookingUserId = null;
			this.showCreateBookingDialog = false;
		},
		async ArchiveConversation() {
			try {
				this.loading = true;
				await this.PatientsService.Post(
					this.Conversation.UserId,
					null,
					"Archive"
				);
				this.$emit("conversationArchived");
			} finally {
				this.loading = false;
			}
		},

		async UnarchiveConversation() {
			try {
				this.loading = true;
				await this.PatientsService.Post(
					this.Conversation.UserId,
					null,
					"Unarchive"
				);
				this.$emit("conversationUnarchived");
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>
